// Third party library
import React from "react";

// Components
import { Header, Segment } from "semantic-ui-react";
import ConfigForm from "./components/ConfigForm";

// Locales
import I18n from "../../../../i18n";

class ProDirectory extends React.Component {
  render() {
    return (
      <Segment>
        <Header as='h3'>{ I18n.t('pro.directory.title') }</Header>
        <Segment>
          <ConfigForm />
        </Segment>
      </Segment>
    )
  }
}

export default ProDirectory;
